import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import generateValidator from './Validations/generateValidator';
import {FormattedHTMLMessage} from 'react-intl';
import withAuthControl from '../auth/Auth.js';
import TopScrolleable from './TopScrolleable.js';
import Section from './Section.js';
import AttributeOptions from './AttributeOptions.js';
import CustomSpinner from './CustomSpinner.js';
import SaveStepButton from './SaveStepButton';

class PryRolForm extends Component {
    constructor(props){
        super(props);
    }

    render() {
        const { handleSubmit, submitting, error } = this.props;
        const options_rol = [{id:0 , name:'Titular'}, {id:1 , name:'Co-Titular'} , {id:2 , name:'Cónyuge No Titular'} , {id:3 , name:'Usufructurario'} , {id:4 , name:'Locatario'} , {id:5 , name:'Comodatario'} , {id:6 , name:'Otros'}]

        return (

             <Section className="intro_form">
                <div className="row">
                <div className="pd-content-left col-md-5 col-lg-5 text-center">
                        <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo-h-blanco.png`)}/>
                        <FormattedHTMLMessage id="app.step_pry_rol" description="Pry Rol"/>
                        <div className="show-desktop">
                            <SaveStepButton/>
                        </div>
                    </div>
                     <div className="pd-content-right text-center short-content col-sm-12 col-md-7 col-lg-7">
                         <form onSubmit={handleSubmit(this.props.setPryRol)} className="pvc-form">
                            {this.props.isLoading && <CustomSpinner message='Estamos analizando tu solicitud. Por favor esperá...' /> }
                            {error && <CustomAlert bsStyle="danger" message={error}/>}
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                    <div className="form-group">
                                        <AttributeOptions name="pry_rol" defaultValue="Carácter del Solicitante" label="Carácter del Solicitante" attributeName='pry_rol' attributeOptions={options_rol}/>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12 text-center">
                                    <button type="submit" className="btn btn-warning btn-lg pd-button pd-form" disabled={submitting}>Continuar</button>
                                </div>
                            </div>
                        </form>
                        <div className="show-mobile">
                          <SaveStepButton/>
                        </div>
                    </div>
                </div>
            </Section>
        );
    }
}

PryRolForm.contextTypes = {
    intl: React.PropTypes.object.isRequired
}

PryRolForm = TopScrolleable(PryRolForm);
let validate = generateValidator([{name: 'pry_rol', required: true}]);

PryRolForm = reduxForm({
    form: 'PryRolForm', // a unique name for this form
    validate
})(PryRolForm);

PryRolForm = withAuthControl(PryRolForm);

export default PryRolForm;



/** WEBPACK FOOTER **
 ** ./src/components/PryRolForm.js
 **/